import { Link } from 'react-router-dom';
import Container from 'components/Container';
import Price from 'components/Price';
import ResponsiveImage from 'components/ResponsiveImage';

/** Numbered routine steps, each with the product we use for it. */
export default function RoutineBlock({ block }) {
  const id = `blk-${block.id}`;
  return (
    <section aria-labelledby={id} className="mt-6 bg-surface-alt py-16 lg:mt-10 lg:py-24">
      <Container>
        <div className="grid gap-6 lg:grid-cols-12">
          <div className="lg:col-span-5">
            {block.eyebrow && <p className="eyebrow mb-3">{block.eyebrow}</p>}
            <h2 id={id} className="font-display text-[2rem] leading-tight text-ink sm:text-[2.75rem]">
              {block.title}
            </h2>
          </div>
          {block.intro && (
            <p className="text-pretty text-muted lg:col-span-4 lg:col-start-9 lg:self-end">{block.intro}</p>
          )}
        </div>
        <ol className="no-scrollbar -mx-4 mt-12 flex snap-x snap-mandatory scroll-px-4 gap-4 overflow-x-auto px-4 sm:-mx-6 sm:px-6 lg:mx-0 lg:grid lg:grid-cols-4 lg:gap-8 lg:overflow-visible lg:px-0">
          {block.steps.map((step, i) => (
            <li
              key={step.title}
              className="relative flex w-[78%] shrink-0 snap-start flex-col border-t border-ink/25 pt-6 sm:w-[44%] lg:w-auto"
            >
              <span aria-hidden="true" className="font-display text-[2.75rem] leading-none text-accent">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="font-display mt-4 text-2xl text-ink">
                <span className="sr-only">{i + 1}. </span>
                {step.title}
              </h3>
              <p className="mt-2 text-pretty text-[15px] text-muted">{step.body}</p>
              {step.product && (
                <Link
                  to={`/produk/${step.product.slug}`}
                  className="group mt-6 flex items-center gap-4 rounded bg-background p-2.5 pr-4 transition-colors hover:bg-surface"
                >
                  <span className="h-[72px] w-[58px] shrink-0 overflow-hidden rounded-sm bg-surface-alt">
                    <ResponsiveImage
                      image={step.product.image}
                      alt=""
                      sizes="58px"
                      className="h-full w-full object-cover"
                    />
                  </span>
                  <span className="min-w-0">
                    <span className="block text-[14px] font-medium leading-snug text-ink group-hover:underline">
                      {step.product.name}
                    </span>
                    <Price
                      amount={step.product.priceAmount}
                      compareAt={step.product.compareAtAmount}
                      from={step.product.priceVaries}
                      size="sm"
                      className="mt-1"
                    />
                  </span>
                </Link>
              )}
            </li>
          ))}
        </ol>
      </Container>
    </section>
  );
}
